export const routes = {
  auth: '/store/auth',
  resetPassword: '/store/reset-password',
  signIn: '/signin',
  signUp: '/signup',
  join: '/join',
  verifyEmail: `/store/verify-email`,
}
